import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { useToast } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const WebhookConfigDetails = () => {
  const { configId } = useParams();
  const decodedId = configId ? atob(configId) : configId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.webhookConfig}${id}/` : null;
  const { data: config, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!config) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(config)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [config]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.webhookConfig}${id}/`);
      showToast('Webhook config deleted successfully', 'success');
      navigate('/customer/webhook-config/list');
    } catch (error) {
      console.error('Error deleting webhook config:', error);
      showToast('Failed to delete webhook config', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={config}
        columns={columns}
        loading={loading}
        entityName="Webhook Config"
        listPath="/customer/webhook-config/list"
        editPath={`/customer/webhook-config/input/${btoa(configId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Webhook Config"
        message="Are you sure you want to delete this webhook config?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default WebhookConfigDetails;
